export const CARD_LOADING = "Chargement de l'encart";
